import * as applicationActions from 'actions/application.js'
import { ctp } from 'services'
import {
  moduleArraySchema,
  vehicleModulesSchema,
  connectorPinsSchema,
} from 'schemas/ecus'
import {
  getCircuitBundles,
  getCircuitDetails,
  getCircuitRevisions,
  getBundleDetails,
  getBundleRevisions,
} from 'services/ctpMapping'
import { createAction } from './utils'

export const CLEAR_CTP_STATE = 'CLEAR_CTP_STATE'
export const CLEAR_CTP_ASSIGNMENT_STATE = 'CLEAR_CTP_ASSIGNMENT_STATE'
export const CLEAR_PIN_ASSIGNMENTS = 'CLEAR_PIN_ASSIGNMENTS'
export const FETCHING_VEHICLE_CTP = 'FETCHING_VEHICLE_CTP'
export const RECEIVED_VEHICLE_CTP = 'RECEIVED_VEHICLE_CTP'
export const FAILED_VEHICLE_CTP_FETCH = 'FAILED_VEHICLE_CTP_FETCH'
export const NO_SERVICE_RECORDS_FOR_VEHICLE = 'NO_SERVICE_RECORDS_FOR_VEHICLE'

export const GET_VEHICLE_CTP = 'GET_VEHICLE_CTP'
export const getCtpInfoForVehicle = ({ serialNumber, moduleName }) =>
  applicationActions.apiAction({
    asyncFn: ctp.getVehicleCtp,
    args: { serialNumber, moduleName },
    successActionType: GET_VEHICLE_CTP,
    id: serialNumber,
    schema: moduleArraySchema,
  })

export const GET_DEFAULT_CTP = 'GET_DEFAULT_CTP'
export const getDefaultCtp = createAction(GET_DEFAULT_CTP, [
  'serialNumber',
  'moduleName',
])

export const RP_CIRCUITS_RECEIVED = 'RP_CIRCUITS_RECEIVED'

export const MOVE_CIRCUIT_FAIL = 'MOVE_CIRCUIT_FAIL'
export const MOVE_CIRCUIT_SUCCESS = 'MOVE_CIRCUIT_SUCCESS'
export const MOVE_CIRCUIT_REQUEST = 'MOVE_CIRCUIT_REQUEST'
export const stubMoveCircuit = ({ serialNumber }) =>
  applicationActions.apiActionStub({
    asyncFn: ctp.moveCircuit,
    successActionType: MOVE_CIRCUIT_SUCCESS,
    failureActionType: MOVE_CIRCUIT_FAIL,
    requestActionType: MOVE_CIRCUIT_REQUEST,
    id: serialNumber,
    args: { serialNumber },
    schema: vehicleModulesSchema,
  })

export const REMOVE_CIRCUIT_SUCCESS = 'REMOVE_CIRCUIT_SUCCESS'
export const REMOVE_CIRCUIT_FAIL = 'REMOVE_CIRCUIT_FAIL'
export const REMOVE_CIRCUIT_REQUEST = 'REMOVE_CIRCUIT_REQUEST'
export const stubRemoveCircuit = ({ serialNumber }) =>
  applicationActions.apiActionStub({
    asyncFn: ctp.removeCircuit,
    successActionType: REMOVE_CIRCUIT_SUCCESS,
    failureActionType: REMOVE_CIRCUIT_FAIL,
    id: serialNumber,
    args: { serialNumber },
    schema: vehicleModulesSchema,
  })

export const RETRIEVED_CIRCUIT_AND_PIN_DATA = 'RETRIEVED_CIRCUIT_AND_PIN_DATA'
export const getCircuitAndPinData = (serialNumber, module, connector) =>
  applicationActions.apiAction({
    asyncFn: ctp.getVehicleModuleConnector,
    args: { serialNumber, module, connector },
    successActionType: RETRIEVED_CIRCUIT_AND_PIN_DATA,
    id: serialNumber,
    schema: connectorPinsSchema({ module, connector }),
  })

export const SELECT_PIN = 'SELECT_PIN'
export const setSelectedPin =
  (location, circuit, includeCircuit = true) =>
  (dispatch, getState) => {
    if (!location) return null

    const ctpState = getState().get('ctp').toJS()
    const pinDetails = Object.values(ctpState.connectorPins).find(
      (details) => details.location === location
    )

    if (!pinDetails) return null

    // eslint-disable-next-line consistent-return
    return dispatch({
      type: SELECT_PIN,
      pinDetails,
      pin: pinDetails,
      ...(circuit && {
        circuit,
        includeCircuit,
      }),
    })
  }

export const CLEAR_PIN_FOR_ASSIGNMENT = 'CLEAR_PIN_FOR_ASSIGNMENT'
export const clearPinForAssignment = () => ({
  type: CLEAR_PIN_FOR_ASSIGNMENT,
})

export const SELECT_PIN_FOR_ASSIGNMENT = 'SELECT_PIN_FOR_ASSIGNMENT'
export const selectPinForAssignment = (pin) => ({
  type: SELECT_PIN_FOR_ASSIGNMENT,
  pin,
})

export const CLEAR_SELECTED_RP = 'CLEAR_SELECTED_RP'
export const SET_SELECTED_RP = 'SET_SELECTED_RP'
export function setSelectedRP(rp) {
  return {
    type: SET_SELECTED_RP,
    rp,
  }
}

export const SET_SELECTED_CIRCUIT = 'SET_SELECTED_CIRCUIT'
export function setSelectedCircuit(circuit) {
  return {
    type: SET_SELECTED_CIRCUIT,
    circuitNumber: circuit.circuitNumber,
    description: circuit.description,
  }
}

export const ADD_CTP_ASSIGNMENT = 'ADD_CTP_ASSIGNMENT'
export const addCtpAssignment = (serialNumber) => ({
  type: ADD_CTP_ASSIGNMENT,
  serialNumber,
})

export const UNDO_CTP_ASSIGNMENT = 'UNDO_CTP_ASSIGNMENT'
export const undoCtpAssignment = (circuitNumber, rpUri) => ({
  type: UNDO_CTP_ASSIGNMENT,
  circuitNumber,
  rpUri,
})

export const UPDATE_CIRCUIT_MAPPED_STATUS = 'UPDATE_CIRCUIT_MAPPED_STATUS'
export const updateCircuitMappedStatus = (rpUri, circuitsThatNeedMapping) => ({
  type: UPDATE_CIRCUIT_MAPPED_STATUS,
  rpUri,
  circuitsThatNeedMapping,
})

export const NO_PINS_AVAILABLE_FOR_CIRCUIT = 'NO_PINS_AVAILABLE_FOR_CIRCUIT'
export const NO_PINS_AVAILABLE_ACKNOWLEDGED = 'NO_PINS_AVAILABLE_ACKNOWLEDGED'

export const CONFIRM_CIRCUIT_MAPPING = 'CONFIRM_CIRCUIT_MAPPING'
export const CIRCUIT_MAPPING_CONFIRMED = 'CIRCUIT_MAPPING_CONFIRMED'

export const CLEAR_HOVERED_PIN = 'CLEAR_HOVERED_PIN'
export const clearHoveredPin = () => ({
  type: CLEAR_HOVERED_PIN,
})
export const SET_HOVERED_PIN = 'SET_HOVERED_PIN'
export const setHoveredPin = (pin) => ({
  type: SET_HOVERED_PIN,
  pin,
})

export const FETCHING_VEHICLE_CTP_REPORT = 'FETCHING_VEHICLE_CTP_REPORT'
export const RECEIVED_VEHICLE_CTP_REPORT = 'RECEIVED_VEHICLE_CTP_REPORT'
export const FAILED_VEHICLE_CTP_REPORT_FETCH = 'FAILED_VEHICLE_CTP_REPORT_FETCH'
export const NO_VEHICLE_CTP_REPORT = 'NO_VEHICLE_CTP_REPORT'
export const GET_VEHICLE_CTP_REPORT = 'GET_VEHICLE_CTP_REPORT'
export const getCtpReport = ({ serialNumber }) =>
  applicationActions.apiAction({
    asyncFn: ctp.getVehicleCtpReport,
    args: { serialNumber },
    successActionType: GET_VEHICLE_CTP_REPORT,
    id: serialNumber,
  })

export const TOGGLE_SELECTED_CTP_REPORT_AS_SERVICED_PIN =
  'TOGGLE_SELECTED_CTP_REPORT_AS_SERVICED_PIN'
export function toggleSelectedCTPReportAsServicedPin(currentRow) {
  return {
    type: TOGGLE_SELECTED_CTP_REPORT_AS_SERVICED_PIN,
    currentRow,
  }
}

export const TOGGLE_SELECTED_CTP_REPORT_AS_BUILT_PIN =
  'TOGGLE_SELECTED_CTP_REPORT_AS_BUILT_PIN'
export function toggleSelectedCTPReportAsBuiltPin(currentRow) {
  return {
    type: TOGGLE_SELECTED_CTP_REPORT_AS_BUILT_PIN,
    currentRow,
  }
}

export const CIRCUIT_BUNDLES_RECEIVED = 'CIRCUIT_BUNDLES_RECEIVED'
export const CIRCUIT_BUNDLES_NOT_RECEIVED = 'CIRCUIT_BUNDLES_NOT_RECEIVED'
export const REQUESTING_CIRCUIT_BUNDLES = 'REQUESTING_CIRCUIT_BUNDLES'
export const requestCircuitBundles = (circuitNumber) =>
  applicationActions.apiAction({
    asyncFn: getCircuitBundles,
    successActionType: CIRCUIT_BUNDLES_RECEIVED,
    failureActionType: CIRCUIT_BUNDLES_NOT_RECEIVED,
    args: { circuitNumber },
  })

export const CIRCUIT_DETAILS_RECEIVED = 'CIRCUIT_DETAILS_RECEIVED'
export const CIRCUIT_DETAILS_NOT_RECEIVED = 'CIRCUIT_DETAILS_NOT_RECEIVED'
export const requestCircuitDetails = (circuitNumber) =>
  applicationActions.apiAction({
    asyncFn: getCircuitDetails,
    successActionType: CIRCUIT_DETAILS_RECEIVED,
    failureActionType: CIRCUIT_DETAILS_NOT_RECEIVED,
    args: { circuitNumber },
  })

export const CIRCUIT_REVISIONS_RECEIVED = 'CIRCUIT_REVISIONS_RECEIVED'
export const CIRCUIT_REVISIONS_NOT_RECEIVED = 'CIRCUIT_REVISIONS_NOT_RECEIVED'
export const requestCircuitRevisions = (circuitNumber) =>
  applicationActions.apiAction({
    asyncFn: getCircuitRevisions,
    successActionType: CIRCUIT_REVISIONS_RECEIVED,
    failureActionType: CIRCUIT_REVISIONS_NOT_RECEIVED,
    args: { circuitNumber },
  })

export const BUNDLE_DETAILS_RECEIVED = 'BUNDLE_DETAILS_RECEIVED'
export const BUNDLE_DETAILS_NOT_RECEIVED = 'BUNDLE_DETAILS_NOT_RECEIVED'

export const requestBundleDetails = (bundleNumber) =>
  applicationActions.apiAction({
    asyncFn: getBundleDetails,
    successActionType: BUNDLE_DETAILS_RECEIVED,
    failureActionType: BUNDLE_DETAILS_NOT_RECEIVED,
    args: { bundleNumber },
  })

export const BUNDLE_REVISIONS_RECEIVED = 'BUNDLE_REVISIONS_RECEIVED'
export const BUNDLE_REVISIONS_NOT_RECEIVED = 'BUNDLE_REVISIONS_NOT_RECEIVED'
export const requestBundleRevisions = (bundleNumber) =>
  applicationActions.apiAction({
    asyncFn: getBundleRevisions,
    successActionType: BUNDLE_REVISIONS_RECEIVED,
    failureActionType: BUNDLE_REVISIONS_NOT_RECEIVED,
    args: { bundleNumber },
  })
